/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li1_TermInputs */

const tr_iade_iptal_s9_li1_term = /** @type {(inputs: Iade_Iptal_S9_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform içi (önerilen):`)
};

const en_iade_iptal_s9_li1_term = /** @type {(inputs: Iade_Iptal_S9_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-platform (recommended):`)
};

const de_iade_iptal_s9_li1_term = /** @type {(inputs: Iade_Iptal_S9_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Plattform (empfohlen):`)
};

const ru_iade_iptal_s9_li1_term = /** @type {(inputs: Iade_Iptal_S9_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В Платформе (рекомендуется):`)
};

/**
* | output |
* | --- |
* | "In-platform (recommended):" |
*
* @param {Iade_Iptal_S9_Li1_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li1_term = /** @type {((inputs?: Iade_Iptal_S9_Li1_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li1_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li1_term(inputs)
	if (locale === "de") return de_iade_iptal_s9_li1_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li1_term(inputs)
	return tr_iade_iptal_s9_li1_term(inputs)
});